import { render, staticRenderFns } from "./EntitySingle.vue?vue&type=template&id=ca865b98&"
import script from "./EntitySingle.vue?vue&type=script&lang=js&"
export * from "./EntitySingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports